import { v4 as uuidv4 } from 'uuid'

export default {
  install (Vue) {
    const vueSession = Vue.prototype.$session

    const userContext = {
      vueSession,

      getCurrentUser () {
        const claims = this.getTokenClaims()
        return claims.cUser
      },

      getUserId () {
        const claims = this.getTokenClaims()
        return claims.UserId
      },

      getEnvironmentId () {
        if (!vueSession.has('environment')) return null
        return vueSession.get('environment').nID
      },

      getEnvironmentName () {
        const claims = this.getTokenClaims()
        return claims.cClient
      },

      getProjectId () {
        if (!vueSession.has('activeProject')) return null
        return vueSession.get('activeProject')
      },

      setProjectId (projectId) {
        vueSession.set('activeProject', projectId)
      },

      getScopes() {
        const claims = this.getTokenClaims()
        return claims.scopes
      },

      getServices () {
        return vueSession.has('services')
          ? vueSession.get('services')
          : null
      },

      getTokenClaims () {
        const token = this.getUserToken()
        if (!token) return null
        return JSON.parse(atob(token.split('.')[1]))
      },

      getUserToken () {
        return vueSession.has('token')
          ? vueSession.get('token')
          : null
      },

      getMessengerId () {
        return vueSession.get('socket-io-id')
      },

      setMessengerId (id) {
        if (id) vueSession.set('socket-io-id', id)
      },

      getUniqueId () {
        return uuidv4()
      }
    }

    Vue.prototype.$userContext = userContext
  }
}
